import { Form, Input, Row, Col, Switch, Select, DatePicker } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const EditComponent = (props: any) => {
    /** 接口标识 */
    const apiId = 'membershipInfo';
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);

    /** 称呼下拉数据 */
    const [appellationData, setAppellationData] = useState<any>();

    useEffect(() => {
        // 拉取“称呼”字典
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'generalData',
                apiVariable: 'appellation',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { appellation } = res.data;
                setAppellationData(appellation);
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        serviceId: 'business',
        // 需要按日期处理的字段
        dateOptions: {
            columnNames: ['dateOfBirth']
        },
        displayOptions: {
            width: 800
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    {/* ============ 第一行：基础身份信息 ============ */}
                    <Col span={6}>
                        <Form.Item
                            label="ID"
                            tooltip='会员信息id'
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="姓名"
                            name="membershipName"
                            rules={[{ required: true, message: '请输入姓名!' }]}>
                            <Input placeholder="请输入姓名" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="称呼"
                            name="appellationId">
                            <Select
                                placeholder="请选择称呼"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general(appellationData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="性别"
                            name="gender">
                            <Select
                                placeholder="性别"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}>
                                {getList.general([{ id: 1, name: '男' }, { id: 0, name: '女' }])}
                            </Select>
                        </Form.Item>
                    </Col>

                    {/* ============ 第二行：关联标识 ============ */}
                    <Col span={12}>
                        <Form.Item
                            label="关键id"
                            name="keyId"
                            tooltip='关键id（系统内部使用，不可编辑）'>
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="unionId"
                            name="unionId"
                            tooltip='微信 unionId（系统内部使用，不可编辑）'>
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    {/* ============ 第三行：联系方式 ============ */}
                    <Col span={8}>
                        <Form.Item
                            label="手机"
                            name="contactNumber"
                            tooltip='用户手机号，多平台关联用，唯一值'>
                            <Input placeholder="请输入手机号" />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="电话号码"
                            name="phoneNumber">
                            <Input placeholder="请输入电话号码" />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="身份证"
                            name="idNumber">
                            <Input placeholder="请输入身份证号" />
                        </Form.Item>
                    </Col>

                    {/* ============ 第四行：生日 / 国籍 / 民族 ============ */}
                    <Col span={8}>
                        <Form.Item
                            label="生日"
                            name="dateOfBirth">
                            <DatePicker
                                style={{ width: '100%' }}
                                placeholder="请选择生日"
                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="国籍"
                            name="nationality"
                            tooltip='会员的国籍'>
                            <Input placeholder="请输入国籍" />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="民族"
                            name="ethnicity"
                            tooltip='会员的民族'>
                            <Input placeholder="请输入民族" />
                        </Form.Item>
                    </Col>

                    {/* ============ 第五行：公司 / 邮编 ============ */}
                    <Col span={16}>
                        <Form.Item
                            label="公司名"
                            name="companyName">
                            <Input placeholder="请输入公司名称" />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="邮政编码"
                            name="postalCode">
                            <Input placeholder="请输入邮政编码" />
                        </Form.Item>
                    </Col>

                    {/* ============ 第六行：地址（加宽） + 状态 ============ */}
                    <Col span={20}>
                        <Form.Item
                            label="地址"
                            name="address">
                            <Input placeholder="请输入详细地址" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            <Switch
                                checkedChildren="启用"
                                unCheckedChildren="关闭"
                            />
                        </Form.Item>
                    </Col>

                    {/* ============ 会员标签 ============ */}
                    <Col span={24}>
                        <Form.Item
                            label="会员标签"
                            name="tags"
                            tooltip="多个标签用英文逗号分隔，例如：VIP,高频,已认证"
                        >
                            <Input placeholder="例如：VIP,高频,已认证" />
                        </Form.Item>
                    </Col>

                    {/* ============ 第七行：备注（整行） ============ */}
                    <Col span={24}>
                        <Form.Item
                            label="备注"
                            name="memo">
                            <Input.TextArea
                                rows={2}
                                placeholder="请输入备注"
                                style={{ resize: 'none' }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;